export default __webpack_public_path__ + "static/product-b-pressxl-gas-1e7e8b4e08deaa904c827a2bdabab7dc.jpg";